import { ComponentRef, FC, useRef } from "react";

import { EligibilityScreenLayout } from "@/blocks/EligibilityScreenLayout";
import { HouseholdMemberAndRelationFormParamsType } from "@/blocks/HouseholdMemberAndRelationForm";
import { VnScrollView } from "@/components/VnScrollView";
import { I18nKeyType } from "@/i18n";

import {
  AddHouseholdMemberScreen,
  AddHouseholdMemberScreenPropsType,
} from "./AddHouseholdMemberScreen";

type EligibilityAddHouseholdMemberScreenPropsType =
  HouseholdMemberAndRelationFormParamsType &
    AddHouseholdMemberScreenPropsType & {
      titleI18nKey: I18nKeyType;
      titleI18nOptions?: Record<string, unknown>;
      descriptionI18nKey: I18nKeyType;
      descriptionI18nOptions?: Record<string, unknown>;
      onBackButtonPress?: () => void;
    };

export const EligibilityAddHouseholdMemberScreen: FC<
  EligibilityAddHouseholdMemberScreenPropsType
> = ({
  titleI18nKey,
  titleI18nOptions,
  descriptionI18nKey,
  descriptionI18nOptions,
  onBackButtonPress,
  ...addHouseholdMemberProps
}) => {
  const scrollViewRef = useRef<ComponentRef<typeof VnScrollView>>(null);

  const handleAddAnother = () => {
    scrollViewRef.current?.scrollTo({ x: 0, y: 0, animated: true });
  };

  // IMPORTANT NOTE: The commented code below is related to a potential future feature allowing users to edit household members from the eligibility flow.
  // The code is intentionally left here for reference and should be removed when the feature is implemented or if it's decided not to be implemented.

  // const [
  //   shouldShowAddHouseholdMemberForm,
  //   setShouldShowAddHouseholdMemberForm,
  // ] = useState(true);

  // const handleBackButtonPress = () => {
  //   setShouldShowAddHouseholdMemberForm(false);
  //   onBackButtonPress?.();
  // };

  // const { data: householdMembers } = useListHouseholdMembersQuery(false);

  return (
    <EligibilityScreenLayout
      // onBackButtonPress={
      //   !shouldShowAddHouseholdMemberForm ? undefined : handleBackButtonPress
      // }
      onBackButtonPress={onBackButtonPress}
      scrollViewRef={scrollViewRef}
      titleI18nKey={
        titleI18nKey ?? "native:addHouseholdMemberScreen.addingMemberTitle"
      }
      titleI18nOptions={titleI18nOptions}
      descriptionI18nOptions={descriptionI18nOptions}
      descriptionI18nKey={
        descriptionI18nKey ??
        "native:addHouseholdMemberScreen.addingMemberDescription"
      }>
      {/* {householdMembers?.map(member => (
        <HouseholdMemberCard
          member={member}
          key={member.id}
          onChangeIsInEditMode={isInEditMode =>
            setShouldShowAddHouseholdMemberForm(!isInEditMode)
          }
        />
      ))} */}

      {/* {shouldShowAddHouseholdMemberForm && ( */}
      <AddHouseholdMemberScreen
        {...addHouseholdMemberProps}
        onAddAnother={handleAddAnother}
      />
      {/*)} */}
    </EligibilityScreenLayout>
  );
};
